export function getElementByQuery({ container, query }) {
    return container.querySelector(query);
}
export function removeClassFromElementByQuery(params) {
    const { className, container, query } = params;
    const element = getElementByQuery({ container, query });
    element?.classList.remove(className);
}
export function updateClassFromElementByQuery(params) {
    const { className, container, query, condition } = params;
    const element = getElementByQuery({ container, query });
    if (condition && element) {
        element.classList.add(className);
    }
    else if (element) {
        element.classList.remove(className);
    }
}
